import { functions, httpsCallable } from "@/firebase/init";

let _proxyFn = null;

// Lazily resolve the callable so importing this module has no side effects.
const _proxy = (payload) => {
  if (!_proxyFn) {
    _proxyFn = httpsCallable(functions, "googleMapsProxy");
  }
  return _proxyFn(payload);
};

export async function geocodeAddress(address) {
  try {
    const res = await _proxy({ type: "geocode", params: { address } });
    if (!res?.data) throw new Error("googleMapsProxy returned no data");
    return res.data;
  } catch (error) {
    throw new Error(`geocodeAddress failed: ${error.message}`);
  }
}

export async function getDirections(origin, destination) {
  try {
    const res = await _proxy({ type: "directions", params: { origin, destination } });
    if (!res?.data) throw new Error("googleMapsProxy returned no data");
    return res.data;
  } catch (error) {
    throw new Error(`getDirections failed: ${error.message}`);
  }
}

export async function validateAddress(body) {
  try {
    const res = await _proxy({ type: "addressValidation", params: { body } });
    if (!res?.data) throw new Error("googleMapsProxy returned no data");
    return res.data;
  } catch (error) {
    throw new Error(`validateAddress failed: ${error.message}`);
  }
}

export async function getStaticMapUrl(lat, lng) {
  try {
    const res = await _proxy({ type: "staticmap", params: { lat, lng } });
    if (!res?.data?.url) throw new Error("googleMapsProxy returned no url");
    return res.data.url;
  } catch (error) {
    throw new Error(`getStaticMapUrl failed: ${error.message}`);
  }
}
